import { useQuery } from "@tanstack/react-query"
import { conversationTicketsQuery } from "../lib/conversationTicketsQuery"

export function useConversationTicketsQuery(...args: Parameters<typeof conversationTicketsQuery>) {
  return useQuery(conversationTicketsQuery(...args))
}
